import * as React from 'react';
import { useEffect } from 'react';
import { Footer } from '../Components/Footer/Footer';
import { VideoDetails } from '../Components/VideoDetails/VideoDetails';

import { VideoPlayer } from '../Components/VideoPlayer/VideoPlayer';
import VideoManager from '../Managers/VideoManager';

var dayjs = require('dayjs')



export const Live = () => {

    useEffect(() => {
        VideoManager.setVideoAsLivestream()
    }, [])
    return(
        <div style={{
            paddingTop: 100,
            backgroundColor: '#04060a'
        }}> 
            <VideoPlayer />
            <VideoDetails video={{
                name: "Livestream",
                program_name: "It Is Written",
                air_date: dayjs().format('MMMM D, YYYY')
            }}/>
            <Footer />


        </div>
    )
}

